import type { TagIntent } from '@omnipresentgroup/design-system';
import {
  type LeaveType,
  type LeaveTypeReason,
  type TimeOff,
  TimeOffStatus,
} from '@omnipresentgroup/types';

export const getTimeOffStatusIntent = (timeOff: TimeOff) => {
  switch (timeOff.status) {
    case TimeOffStatus.deleted: {
      return 'error';
    }
    default: {
      return 'default';
    }
    case TimeOffStatus.scheduled: {
      return 'success';
    }
  }
};

export const getTimeOffTypeIntent = (isCustom: boolean): TagIntent => {
  if (isCustom) {
    return 'info';
  }
  return 'default';
};

export const getTimeOffTypeValue = (leaveType: LeaveType) =>
  leaveType.replace('op:leave:', '');

export const leaveTypeReasons: LeaveTypeReason[] = [
  'sick',
  'compassionate',
  'holiday',
  'other',
  'unknown',
];
